import { render, staticRenderFns } from "./TuitionFee.vue?vue&type=template&id=3084fd4e"
import script from "./TuitionFee.vue?vue&type=script&lang=js"
export * from "./TuitionFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports